import { render, staticRenderFns } from "./ModelGenerator.vue?vue&type=template&id=21d63163&scoped=true&"
import script from "./ModelGenerator.vue?vue&type=script&lang=js&"
export * from "./ModelGenerator.vue?vue&type=script&lang=js&"
import style0 from "./ModelGenerator.vue?vue&type=style&index=0&id=21d63163&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d63163",
  null
  
)

export default component.exports